// global config
export const MAX_UPLOAD_FILE_NUMBER = 12;

// upload images
export const MAX_UPLOAD_IMAGE_SIZE = 10; // 10MB
export const MIN_UPLOAD_IMAGE_WIDTH = 300;
export const MIN_UPLOAD_IMAGE_HEIGHT = 300;
export const ALLOWED_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'webp'];

// upload files
export const MAX_UPLOAD_FILE_SIZE = 120; // 120MB
export const ALLOWED_FILE_TYPES = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'zip',
    'csv',
    'webm',
    'mp4',
];
